import * as React from "react";
import * as SeparatorPrimitive from "@radix-ui/react-separator";
import { cn } from "../../lib/utils";

export interface SeparatorProps
    extends React.ComponentPropsWithoutRef<typeof SeparatorPrimitive.Root> {
    /**
     * `default` is `--border` (#CDD1DF), unchanged since before #455.
     * `subtle` is `--muted` (#E6E8EF) — the Figma "Divider" colour
     * (docs/design-library/01-figma-components.md), an exact token match.
     */
    variant?: "default" | "subtle";
}

const Separator = React.forwardRef<
    React.ElementRef<typeof SeparatorPrimitive.Root>,
    SeparatorProps
>(({ className, orientation = "horizontal", decorative = true, variant = "default", ...props }, ref) => (
    <SeparatorPrimitive.Root
        ref={ref}
        decorative={decorative}
        orientation={orientation}
        className={cn(
            "shrink-0",
            variant === "subtle" ? "bg-muted" : "bg-border",
            orientation === "horizontal" ? "h-px w-full" : "h-full w-px",
            className,
        )}
        {...props}
    />
));
Separator.displayName = SeparatorPrimitive.Root.displayName;

export { Separator };
